import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import App from './App';
import { CurrencyProvider } from './components/CurrencyContext';
import reportWebVitals from './reportWebVitals'; 
import { CountryProvider } from './components/CountryContext';

const container = document.getElementById('root');
hydrateRoot(
  container,
  <CountryProvider>
  <CurrencyProvider>
    <App />
  </CurrencyProvider>
  </CountryProvider>
);

reportWebVitals(); 
